export const formatReimbursementFileName = (
  file: File,
  {
    date,
    category,
    vendor,
    item,
    price,
    index,
    username,
  }: {
    date?: string;
    category?: number;
    vendor?: string;
    item?: string;
    price?: number;
    index?: number;
    username?: string;
  },
): string => {
  const today = new Date();
  const dateStr = date
    ? new Date(date).toISOString().slice(0, 10).replace(/-/g, "")
    : today.toISOString().slice(0, 10).replace(/-/g, "");

  const categoryNum = category ? category : 0;
  const userName = username?.replace(/[\s.-]/g, "_") ?? "User";
  const vendorText = vendor ? vendor.replace(/[\s.\-&]/g, "_") : "NoInfo";
  const itemText = item ? item.replace(/[\s.\-&]/g, "_") : "NoInfo";
  const priceNum = price ? price : 0;

  const extension = file.name.split(".").pop() || "";
  const baseFileName = `${dateStr}_${categoryNum}_${userName}_${vendorText}_${itemText}_${priceNum}`;

  return typeof index === "number" && index > 0
    ? `${baseFileName}_${index}.${extension}`
    : `${baseFileName}.${extension}`;
};

/**
 * Generates a filename for the merged PDF based on reimbursement data
 */
export const formatMergedPdfFileName = ({
  date,
  category,
  vendor,
  item,
  price,
  username,
}: {
  date?: string;
  category?: number;
  vendor?: string;
  item?: string;
  price?: number;
  username?: string;
}): string => {
  const today = new Date();
  const dateStr = date
    ? new Date(date).toISOString().slice(0, 10).replace(/-/g, "")
    : today.toISOString().slice(0, 10).replace(/-/g, "");

  const categoryNum = category ? category : 0;
  const userName = username?.replace(/[\s.-]/g, "_") ?? "User";
  // Replace spaces, dots, hyphens, and ampersands with hyphens (not underscores)
  const vendorText = vendor ? vendor.replace(/[\s.\-&]/g, "-") : "NoInfo";
  const itemText = item ? item.replace(/[\s.\-&]/g, "-") : "NoInfo";
  const priceNum = price ? price : 0;

  const baseFileName = `${dateStr}_${categoryNum}_${userName}_${vendorText}_${itemText}_${priceNum}`;

  return `${baseFileName}.pdf`;
};
